<template>
  <div>
    <select v-model="taskToSkip">
      <option v-for="task in tasks" :value="task" :key="task.taskReferenceName">
        {{ task.name }} - {{ task.taskReferenceName }}
      </option>
    </select>
    <pre v-if="taskToSkip">{{ taskToSkip.taskDefinition }}</pre>
    <JsonEditor v-model="skipTaskPayload" />
    <button
      @click="skipWorkflowTask([taskToSkip.taskReferenceName, skipTaskPayload])"
    >
      Skip Task
    </button>
    <router-link
      tag="button"
      :to="{ name: 'workflow', params: { workflowId: workflowId } }"
    >
      Cancel
    </router-link>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import JsonEditor from '@/components/JsonEditor.vue'

// TODO Select a Task from Workflow to populate payload
export default {
  name: 'WorkflowSkipTask',
  props: ['workflowId'],
  data() {
    return {
      taskToSkip: {},
      skipTaskPayload: {
        taskInput: {},
        taskOutput: {}
      }
    }
  },
  computed: mapGetters({
    tasks: 'workflowTasksDefined'
  }),
  methods: mapActions(['getWorkflow', 'skipWorkflowTask']),
  created() {
    this.getWorkflow(this.workflowId)
  },
  watch: {
    workflowId: function() {
      this.getWorkflow(this.workflowId)
    }
  },
  components: {
    JsonEditor
  }
}
</script>
